import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { AppView, SCROLL_INDICATOR_INSETS, SettingsItemNavigate, withAnimatedNavigationHeader } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { IconMoneyBag } from 'design-system/icons/IconMoneyBag';
import IconLineUp from 'design-system/icons/IconLineUp';
import useColors from 'hooks/useColors';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { getTransferProviders } from 'features/invest/actions';
import { useAppDispatch } from 'store/hooks';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Select your account type',
    subTitle: {
        ISA: 'Make sure this is the account type you’re transferring your ISA from',
        JISA: 'Make sure this is the account type you’re transferring your child’s Junior ISA from',
    },
    cashIsa: {
        ISA: 'Cash ISA',
        JISA: 'Junior Cash ISA',
    },
    stocksAndSharesIsa: {
        ISA: 'Stocks & Shares ISA',
        JISA: 'Junior Stocks & Shares ISA',
    },
};
const SelectTransferAccountType = withAnimatedNavigationHeader(({ navigation, route, scrollHandler }) => {
    const { accountId } = route.params;
    const tradingAccountType = accountId ? 'JISA' : 'ISA';
    const colors = useColors();
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(getTransferProviders(tradingAccountType, 'CASH'));
        dispatch(getTransferProviders(tradingAccountType, 'STOCKS_AND_SHARES'));
    }, [dispatch, tradingAccountType]);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const handleSelectCashIsa = useCallback(() => {
        navigation.navigate('ProductTransferSearchProvider', { type: 'CASH', accountId });
    }, [accountId]);
    const handleSelectStocksAndSharesIsa = useCallback(() => {
        navigation.navigate('ProductTransferSearchProvider', { type: 'STOCKS_AND_SHARES', accountId });
    }, [accountId]);
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={paddingHorizontalStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <ScreenInfoHeader title={strings.title} subTitle={strings.subTitle[tradingAccountType]}/>
          <TouchableBounceCard onPress={handleSelectCashIsa} onDark noMarginTop>
            <View pointerEvents="none">
              <SettingsItemNavigate icon={<IconMoneyBag gradientKey="orange"/>} titleFirst title={strings.cashIsa[tradingAccountType]}/>
            </View>
          </TouchableBounceCard>
          <TouchableBounceCard onPress={handleSelectStocksAndSharesIsa} onDark noMarginTop>
            <View pointerEvents="none">
              <SettingsItemNavigate titleFirst icon={<IconLineUp colorKey="investment"/>} title={strings.stocksAndSharesIsa[tradingAccountType]}/>
            </View>
          </TouchableBounceCard>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default SelectTransferAccountType;
